/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface GetUnidadAcabadosInfoOutput {
  zonas?: FEAcabadoZonaInfoDTO[]
}

export interface FEAcabadoZonaInfoDTO {
  /** @format int32 */
  idAcabadoUnidad: number
  zona?: string
}

export interface FEAcabadoZonaModeloAcabadosInfoDTO {
  zona?: string
  modelo?: string
  acabados?: FEAcabadoZonaAcabadoInfoDTO[]
}

export interface FEAcabadoZonaAcabadoInfoDTO {
  /** @format int32 */
  idAcabadoUnidadModeloAcabado: number
  acabado?: string
}

export interface TexturasDTO {
  /** @format int32 */
  idTexturas?: number
  /** @format int32 */
  identificadorTextura?: number
  /** @format int32 */
  idGruposDeTexturas?: number
  nombre?: string
  descripcion?: string
  nombreFichero?: string
  ruta?: string
  url?: string
  urlMiniatura?: string
  /** @format decimal */
  factorRepeticionX?: number
  /** @format decimal */
  factorRepeticionY?: number
  /** @format decimal */
  opacidad?: number
  /** @format decimal */
  reflejo?: number
  /** @format decimal */
  rugosidad?: number
  /** @format int32 */
  color?: number
  /** @format decimal */
  metal?: number
  /** @format decimal */
  brillo?: number
  espejo?: boolean
  miniatura?: string
  rugosidadFichero?: string
  /** @format decimal */
  factorDeEscala?: number
  descatalogado?: boolean
  /** @format int32 */
  idDependencias?: number
  grupo?: GrupoTexturasDTO
}

export interface GrupoTexturasDTO {
  /** @format int32 */
  idGruposDeTexturas?: number
  ruta?: string
  url?: string
  nombre?: string
  subGrupos?: GrupoTexturasDTO[]
}

export interface FEElementoEnlazadoUnidadAcabadosDTO {
  /** @format int32 */
  idElementosEnlazados?: number
  /** @format int32 */
  idUnidadEnlazada?: number
  descripcion?: string
  referenciaJpgpng?: string
  /** @format int32 */
  ordenVisual?: number
  porDefecto: boolean
}

export interface FEElementosEnlazadosDTO {
  /** @format int32 */
  idElementosEnlazados: number
  /** @format int32 */
  nodoPadre?: number
  /** @format int32 */
  nodo?: number
  descripcion?: string
  /** @format decimal */
  cantidad?: number
  /** @format decimal */
  posicionX?: number
  /** @format decimal */
  posicionY?: number
  /** @format decimal */
  posicionZ?: number
  /** @format decimal */
  rotacionX?: number
  /** @format decimal */
  rotacionY?: number
  /** @format decimal */
  rotacionZ?: number
  desenlazar?: boolean
  childs: FEElementosEnlazadosDTO[]
  unidad?: FEUnidadDTO
}

export interface FEUnidadDTO {
  /** @format int32 */
  idUnidades?: number
  codigo?: string
  referencia?: string
  referenciaBlender?: string
  referenciaJpgpng?: string
  elemento?: boolean
  descripcion?: string
  descripcionLarga?: string
  /** @format decimal */
  ancho?: number
  /** @format decimal */
  fondo?: number
  /** @format decimal */
  alto?: number
  mano?: EMano
  /** @format decimal */
  altura?: number
  alturaHaciaAbajo?: boolean
  colision?: boolean
  /** @format decimal */
  cota?: number
  tipoNormalizado?: string
  tipoUnidNorm?: string
  modificarAncho?: boolean
  modificarFondo?: boolean
  modificarAlto?: boolean
  /** @format decimal */
  anchoMinimo?: number
  /** @format decimal */
  fondoMinimo?: number
  /** @format decimal */
  altoMinimo?: number
  /** @format decimal */
  anchoMaximo?: number
  /** @format decimal */
  fondoMaximo?: number
  /** @format decimal */
  altoMaximo?: number
  /** @format decimal */
  alturaColocacion?: number
  /** @format decimal */
  offsetVentanasPuertas?: number
  universal?: boolean
  /** @format int32 */
  paginaPdf?: number
  url?: string
  /** @format decimal */
  precio?: number
  unidadesLuces?: UnidadesLucesDTO[]
  morphs?: MorphDTO[]
  acabados?: FEAcabadoUnidadDTO[]
  elementosEnlazados?: FEElementosEnlazadosDTO[]
}

export enum EMano {
  D = 1,
  I = 2,
  A = 3,
}

export interface UnidadesLucesDTO {
  /** @format int32 */
  idUnidadesLuces?: number
  /** @format int32 */
  tipoLuz?: number
  tipoLuzDescripcion?: string
  /** @format decimal */
  intensity?: number
  /** @format int32 */
  color?: number
  /** @format decimal */
  distance?: number
  /** @format decimal */
  angle?: number
  /** @format decimal */
  penumbra?: number
  /** @format decimal */
  power?: number
  castShadow?: boolean
}

export interface MorphDTO {
  /** @format int32 */
  idMorph?: number
  nombre?: string
  tipo?: string
  /** @format decimal */
  valor?: number
  /** @format decimal */
  valorMin?: number
  /** @format decimal */
  valorMax?: number
  /** @format int32 */
  orden?: number
}

export interface FEAcabadoUnidadDTO {
  /** @format int32 */
  idAcabadoUnidad?: number
  zona?: string
  modelo?: string
  acabado?: string
  descripcion?: string
  texturas?: FEUnidadTexturasDTO
  /** @format decimal */
  orientacionTextura?: number
}

export interface FEUnidadTexturasDTO {
  /** @format int32 */
  idTexturas?: number
  /** @format int32 */
  idGruposDeTexturas?: number
  /** @format int32 */
  identificadorTextura?: number
  nombre?: string
  descripcion?: string
  url?: string
  /** @format decimal */
  factorRepeticionX?: number
  /** @format decimal */
  factorRepeticionY?: number
  /** @format decimal */
  opacidad?: number
  /** @format decimal */
  reflejo?: number
  /** @format decimal */
  rugosidad?: number
  /** @format int32 */
  color?: number
  /** @format decimal */
  metal?: number
  /** @format decimal */
  brillo?: number
  espejo?: boolean
  miniatura?: string
  rugosidadFichero?: string
  /** @format decimal */
  factorDeEscala?: number
}

export interface FEAcabadoTexturasDTO {
  /** @format int32 */
  idAcabadoUnidadModeloAcabado: number
  /** @format int32 */
  idAcabadoUnidad: number
  zona?: string
}

export interface AuthOutput {
  token?: string
  rememberToken?: string
  cleanRembemberToken: boolean
  sessionId?: string
  canChangeNoEditable: boolean
  prefsInfo?: PrefInfo[]
  prefs?: Record<string, any>
  impuestos?: ImpuestosDTO[]
  idioma?: IdiomaDTO
  textos?: JsonObject
}

export interface PrefInfo {
  nombre?: string
  descripcion?: string
  typeValor?: string
  noEditable: boolean
}

export interface ImpuestosDTO {
  /** @format int32 */
  idImpuestos?: number
  /** @format int32 */
  codigoImpuestos?: number
  nombreImpuesto?: string
  /** @format decimal */
  porcentaje?: number
  porDefecto?: boolean
}

export interface IdiomaDTO {
  /** @format int32 */
  id?: number
  codigo?: string
  nombreCultura?: string
  idioma?: string
}

export type JsonObject = JsonNode & {
  Dictionary: JsonPropertyDictionaryOfJsonNode
  /** @format int32 */
  Count: number
}

export interface JsonPropertyDictionaryOfJsonNode {
  list?: KeyValuePairOfStringAndJsonNode[]
  /** @format int32 */
  count: number
  keys?: string[]
  values?: JsonNode[]
  isReadOnly: boolean
}

export interface KeyValuePairOfStringAndJsonNode {
  key: string
  value: JsonNode
}

export interface JsonNode {
  options?: JsonNodeOptions
  parent?: JsonNode
  root: JsonNode
}

export interface JsonNodeOptions {
  propertyNameCaseInsensitive: boolean
}

export interface AuthInput {
  correo?: string
  password?: string
  public?: boolean
  remember?: boolean
  cleanRembemberToken?: boolean
}

export interface UserAutenticatedOutput {
  isPublic?: boolean
  name?: string
  correo?: string
}

export interface MessageOutput {
  message?: string
}

export interface RegisterUserInput {
  nombre?: string
  apellidos?: string
  direccion?: string
  cPostal?: string
  telefono?: string
  /** @format int32 */
  idIdioma?: number
  empresa?: string
  cif?: string
  ciudad?: string
  pais?: string
  correo?: string
  correoConfirmar?: string
  password?: string
  passwordConfirmar?: string
  confirmarTerminos: boolean
}

export interface ModificarUsuarioDTO {
  nombre?: string
  apellidos?: string
  direccion?: string
  codigoPostal?: string
  telefono?: string
  /** @format int32 */
  idIdioma?: number
  empresa?: string
  cif?: string
  ciudad?: string
  pais?: string
  correo?: string
  passwordActual?: string
  passwordNuevo?: string
  passwordConfirmar?: string
  esEmpresa: boolean
}

export type ModificarUsuarioOutput = MessageOutput & {
  token?: string
  rememberToken?: string
  cleanRembemberToken: boolean
}

export interface GuardarDisenoOutput {
  /** @format int32 */
  idDisenos?: number
  /** @format int32 */
  idVersiones?: number
}

export interface FEProyectDTO {
  disenyo?: FEDisenosDTO
  escena?: FEEscenaDTO
  /** @format date-time */
  fecha?: string
}

export interface FEDisenosDTO {
  /** @format int32 */
  idDisenos?: number
  /** @format int32 */
  idVersiones?: number
  /** @format int32 */
  idImpuestos?: number
  nombreProyecto?: string
  descripcion?: string
  nombre?: string
  apellidos?: string
  direccion?: string
  codPostal?: string
  poblacion?: string
  pais?: string
  email?: string
  movil?: string
  numProyectoTpc?: string | null
}

export interface FEEscenaDTO {
  json?: string
  objetosEscena?: FEObjectsEscenaDTO
  visualesNombradas?: FEVisualNombradaDTO[]
  /** @format decimal */
  precio?: number
}

export interface FEObjectsEscenaDTO {
  objetos?: ObjectEscenaDTO[]
}

export interface ObjectEscenaDTO {
  /** @format int32 */
  idUnidades?: number
  zonas?: ZonaObjectEscenaDTO[]
}

export interface ZonaObjectEscenaDTO {
  zona?: string
  /** @format int32 */
  idTexturas?: number
}

export type FEVisualNombradaDTO = FEVisualNombradaWithoutNameDTO & {
  nombre?: string
}

export interface FEVisualNombradaWithoutNameDTO {
  /** @format int32 */
  idHqrenders?: number
  imageUrl?: string
}

export interface IdDescripcionDTOOfEOrdenacionDisenyos {
  id: EOrdenacionDisenyos
  description?: string
}

export enum EOrdenacionDisenyos {
  Nombre = 0,
  Apellidos = 1,
  Email = 2,
  Movil = 3,
  FechaDeInicio = 4,
  FechaUltimaModificacion = 5,
  Estado = 6,
}

export interface GetDisenyoOutput {
  disenyo?: FEDisenosFechasDTO
  escena?: FEEscenaDTO
}

export type FEDisenosFechasDTO = FEDisenosDTO & {
  /** @format date-time */
  fechaCreacion?: string
  /** @format date-time */
  fechaUltimaModificacion?: string
}

export interface GetDisenyosInput {
  filtro?: FiltroDisenyos
  /** @format date-time */
  date?: string
}

export interface FiltroDisenyos {
  ordenacion?: EOrdenacionDisenyos
  texto?: string
}

export interface AbrirDisenyoOutput {
  json?: string
  disenyo?: FEDisenosFechasDTO
  unidades?: FEUnidadDTO[]
  texturas?: TexturasDTO[]
}

export interface DuplicarDisenyoInput {
  /** @format int32 */
  idVersiones: number
  disenyo: FEDisenosDTO
  /**
   * @format date-time
   * @minLength 1
   */
  fecha: string
}

export interface FEDetalleDisenosCabDTO {
  /** @minLength 1 */
  sessionID: string
  lineas: FEDetalleDisenosLinDTO[]
}

export interface FEDetalleDisenosLinDTO {
  /** @format int32 */
  ordenEntrada: number
  /** @format int32 */
  idUnidades: number
  enlaces?: FEDetalleDisenosLinDTO[]
  /** @format decimal */
  x: number
  /** @format decimal */
  y: number
  /** @format decimal */
  z: number
  /** @format decimal */
  ancho: number
  /** @format decimal */
  fondo: number
  /** @format decimal */
  alto: number
  mano?: EMano
}

export interface GeneratePdfDocVentaInput {
  /** @format int32 */
  idVersiones: number
  descripcionImpuestos: boolean
  /** @minLength 1 */
  moneda: string
  /** @format int32 */
  numeroDecimales: number
  imagenUnidades: boolean
  ptoReferencia: boolean
  ptoDescPorLinea: boolean
  ptoCantidad: boolean
  ptoPrecio: boolean
  ptoPrecio1: boolean
  ptoPrecio2: boolean
  ptoPrecio3: boolean
  agruparUnidades: boolean
  idHqrendersSelected?: number[]
  unidades: Unidad[]
}

export interface Unidad {
  /** @format int32 */
  idUnidades: number
  acabados?: Acabado[]
  enlaces?: Unidad[]
}

export interface Acabado {
  /** @format int32 */
  idAcabadoUnidad: number
  /** @format int32 */
  idTexturas: number
}

export interface UrlNameDTO {
  url?: string
  name?: string
}

export interface LoadIdiomaOutput {
  idioma?: IdiomaDTO
  textos?: JsonObject
}

export interface FEMenusDTO {
  claveMenu?: string
  /** @format int32 */
  anchoicono?: number
  /** @format int32 */
  altoicono?: number
  texto?: string
  submenus?: FEMenusItemsDTO[]
}

export interface FEMenusItemsDTO {
  /** @format int32 */
  id?: number
  claveMenuItem?: string
  /** @format int32 */
  orden: number
  texto?: string
  icono?: string
  clavemenuabrir?: string
  accion?: string
  args?: string[]
  /** @format int32 */
  idUnidades?: number
  codigoUnidad?: string
  referencia?: string
  descripcion?: string
  descripcionLarga?: string
  /** @format decimal */
  ancho?: number
  /** @format decimal */
  alto?: number
  /** @format decimal */
  fondo?: number
  morphs?: MorphDTO[]
}

export interface GetMenuInput {
  clavemenu?: string
  filtro?: FiltroMenu
}

export interface FiltroMenu {
  texto?: string
}

export interface UpdatePreferenceInput {
  nombre?: string
  valor?: any
}

export interface GetGrupoTexturasInput {
  universal?: boolean
  catalogoName?: string
  version?: string
  /** @format int32 */
  identificador?: number
  /** @format int32 */
  idCatalogos?: number
  texto?: string
}

export interface GetTexturasInput {
  /** @format int32 */
  idGruposDeTexturas?: number
  texto?: string
}

export interface GetFEUnidadInput {
  /** @minLength 1 */
  codigo: string
  /** @format date-time */
  date?: string
  catalogoId?: string
}

export interface GetFEInfoPuertaVentanaOutput {
  manos?: ETiposPuertasVentanas[]
  bisagras?: ETiposPuertasVentanas[]
  combinaciones?: Combinacion[]
}

export enum ETiposPuertasVentanas {
  None = 'None',
  Interior = 'Interior',
  Exterior = 'Exterior',
  BitIntExt = 'BitIntExt',
  Izquierda = 'Izquierda',
  Derecha = 'Derecha',
  BitIzqDer = 'BitIzqDer',
  Corredera = 'Corredera',
  Ventana = 'Ventana',
  BitTipo = 'BitTipo',
}

export interface Combinacion {
  mano?: ETiposPuertasVentanas
  bisagra?: ETiposPuertasVentanas
  /** @format int32 */
  idUnidades?: number
}

export type QueryParamsType = Record<string | number, any>
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat
  /** request body */
  body?: unknown
  /** base url */
  baseUrl?: string
  /** request cancellation token */
  cancelToken?: CancelToken
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void
  customFetch?: typeof fetch
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D
  error: E
}

type CancelToken = Symbol | string | number

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = 'http://h23api.for2home.com'
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private abortControllers = new Map<CancelToken, AbortController>()
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams)

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  }

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig)
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key)
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key])
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key]
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&')
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {}
    const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key])
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join('&')
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery)
    return queryString ? `?${queryString}` : ''
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string')
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== 'string' ? JSON.stringify(input) : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key]
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        )
        return formData
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  }

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken)
      if (abortController) {
        return abortController.signal
      }
      return void 0
    }

    const abortController = new AbortController()
    this.abortControllers.set(cancelToken, abortController)
    return abortController.signal
  }

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken)

    if (abortController) {
      abortController.abort()
      this.abortControllers.delete(cancelToken)
    }
  }

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const queryString = query && this.toQueryString(query)
    const payloadFormatter = this.contentFormatters[type || ContentType.Json]
    const responseFormat = format || requestParams.format

    const normalizedBaseUrl = (baseUrl || this.baseUrl || '').replace(/\/$/, '') + '/'
    const normalizedPath = path.startsWith('/') ? path.slice(1) : path

    return this.customFetch(
      `${normalizedBaseUrl}${normalizedPath}${queryString ? `?${queryString}` : ''}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
        },
        signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
        body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>
      r.data = null as unknown as T
      r.error = null as unknown as E

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data
              } else {
                r.error = data
              }
              return r
            })
            .catch((e) => {
              r.error = e
              return r
            })

      if (cancelToken) {
        this.abortControllers.delete(cancelToken)
      }

      if (!response.ok) throw data
      return data
    })
  }
}

/**
 * @title My Title
 * @version 1.0.0
 * @baseUrl https://h23api.for2home.com
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Acabados
     * @name AcabadosGetUnidadAcabadosInfo
     * @request GET:api/Acabados/getunidadacabadosinfo/{idUnidades}
     * @secure
     */
    acabadosGetUnidadAcabadosInfo: (idUnidades: number, params: RequestParams = {}) =>
      this.request<GetUnidadAcabadosInfoOutput, any>({
        path: `api/Acabados/getunidadacabadosinfo/${idUnidades}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Acabados
     * @name AcabadosGetAcabadoZonaModeloAcabadoInfo
     * @request GET:api/Acabados/getacabadozonamodeloacabadoinfo/{idAcabadoUnidad}
     * @secure
     */
    acabadosGetAcabadoZonaModeloAcabadoInfo: (
      idAcabadoUnidad: number,
      params: RequestParams = {},
    ) =>
      this.request<FEAcabadoZonaModeloAcabadosInfoDTO[], any>({
        path: `api/Acabados/getacabadozonamodeloacabadoinfo/${idAcabadoUnidad}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Acabados
     * @name AcabadosGetTexturas
     * @request GET:api/Acabados/gettexturas/{idAcabadoUnidadModeloAcabado}
     * @secure
     */
    acabadosGetTexturas: (idAcabadoUnidadModeloAcabado: number, params: RequestParams = {}) =>
      this.request<TexturasDTO[], any>({
        path: `api/Acabados/gettexturas/${idAcabadoUnidadModeloAcabado}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Acabados
     * @name AcabadosGetElementosEnlazadosUnidadAcabados
     * @request GET:api/Acabados/getelementosenlazadosunidadacabados/{idUnidades}
     * @secure
     */
    acabadosGetElementosEnlazadosUnidadAcabados: (idUnidades: number, params: RequestParams = {}) =>
      this.request<Record<string, Record<string, FEElementoEnlazadoUnidadAcabadosDTO[]>>, any>({
        path: `api/Acabados/getelementosenlazadosunidadacabados/${idUnidades}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Acabados
     * @name AcabadosGetElementosEnlazadosUnidadAcabados2
     * @request GET:api/Acabados/getelementosenlazadosunidadacabados/{idElementosEnlazadosAnt}/{idElementosEnlazados}
     * @secure
     */
    acabadosGetElementosEnlazadosUnidadAcabados2: (
      idElementosEnlazadosAnt: number,
      idElementosEnlazados: number,
      params: RequestParams = {},
    ) =>
      this.request<FEElementosEnlazadosDTO, any>({
        path: `api/Acabados/getelementosenlazadosunidadacabados/${idElementosEnlazadosAnt}/${idElementosEnlazados}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Acabados
     * @name AcabadosBuscarTexturaEnUnidad
     * @request GET:api/Acabados/buscartexturaenunidad/{idUnidades}/{idTexturas}
     * @secure
     */
    acabadosBuscarTexturaEnUnidad: (
      idUnidades: number,
      idTexturas: number,
      params: RequestParams = {},
    ) =>
      this.request<FEAcabadoTexturasDTO[], any>({
        path: `api/Acabados/buscartexturaenunidad/${idUnidades}/${idTexturas}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthNewSession
     * @request GET:api/Auth/newSession
     * @secure
     */
    authNewSession: (params: RequestParams = {}) =>
      this.request<AuthOutput, any>({
        path: `api/Auth/newSession`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthAuthenticate
     * @request POST:api/Auth/authenticate
     * @secure
     */
    authAuthenticate: (info: AuthInput, params: RequestParams = {}) =>
      this.request<AuthOutput, any>({
        path: `api/Auth/authenticate`,
        method: 'POST',
        body: info,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthIsAuthenticated
     * @request GET:api/Auth/isAuthenticated
     * @secure
     */
    authIsAuthenticated: (params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `api/Auth/isAuthenticated`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthGetUserAutenticated
     * @request GET:api/Auth/getUserAuthenticated
     * @secure
     */
    authGetUserAutenticated: (params: RequestParams = {}) =>
      this.request<UserAutenticatedOutput, any>({
        path: `api/Auth/getUserAuthenticated`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthRegister
     * @request POST:api/Auth/register
     * @secure
     */
    authRegister: (input: RegisterUserInput, params: RequestParams = {}) =>
      this.request<MessageOutput, any>({
        path: `api/Auth/register`,
        method: 'POST',
        body: input,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthGetUserAct
     * @request GET:api/Auth/getUserAct
     * @secure
     */
    authGetUserAct: (params: RequestParams = {}) =>
      this.request<ModificarUsuarioDTO, any>({
        path: `api/Auth/getUserAct`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthModifyUserAct
     * @request POST:api/Auth/modifyUserAct
     * @secure
     */
    authModifyUserAct: (user: ModificarUsuarioDTO, params: RequestParams = {}) =>
      this.request<ModificarUsuarioOutput, any>({
        path: `api/Auth/modifyUserAct`,
        method: 'POST',
        body: user,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Guarda diseño
     *
     * @tags Diseno
     * @name DisenoGuardar
     * @summary Guardar el diseño, la primera vez idDisenos y idVersiones no se tienen que definir sino NombreProyecto,..... En las otras llamadas solo poner idDisenos y idVersiones que se ha retornado en la primera llamada
     * @request POST:api/Diseno/guardar
     * @secure
     */
    disenoGuardar: (input: FEProyectDTO, params: RequestParams = {}) =>
      this.request<GuardarDisenoOutput, any>({
        path: `api/Diseno/guardar`,
        method: 'POST',
        body: input,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diseno
     * @name DisenoGetCamposOrdenacion
     * @request GET:api/Diseno/getcamposordenacion
     * @secure
     */
    disenoGetCamposOrdenacion: (params: RequestParams = {}) =>
      this.request<IdDescripcionDTOOfEOrdenacionDisenyos[], any>({
        path: `api/Diseno/getcamposordenacion`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diseno
     * @name DisenoGetDisenyos
     * @request POST:api/Diseno/getdisenyos
     * @secure
     */
    disenoGetDisenyos: (input: GetDisenyosInput, params: RequestParams = {}) =>
      this.request<GetDisenyoOutput[], any>({
        path: `api/Diseno/getdisenyos`,
        method: 'POST',
        body: input,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diseno
     * @name DisenoAbrirDisenyo
     * @request GET:api/Diseno/abrirdisenyo/{idVersiones}
     * @secure
     */
    disenoAbrirDisenyo: (idVersiones: number, params: RequestParams = {}) =>
      this.request<AbrirDisenyoOutput, any>({
        path: `api/Diseno/abrirdisenyo/${idVersiones}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diseno
     * @name DisenoAbrirDisenyoTmp
     * @request GET:api/Diseno/abrirdisenyotmp/{idVersiones}
     * @secure
     */
    disenoAbrirDisenyoTmp: (idVersiones: number, params: RequestParams = {}) =>
      this.request<AbrirDisenyoOutput, any>({
        path: `api/Diseno/abrirdisenyotmp/${idVersiones}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diseno
     * @name DisenoBorrarDisenyo
     * @request GET:api/Diseno/borrarversion/{idVersiones}
     * @secure
     */
    disenoBorrarDisenyo: (idVersiones: number, params: RequestParams = {}) =>
      this.request<File | null, any>({
        path: `api/Diseno/borrarversion/${idVersiones}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diseno
     * @name DisenoDuplicarDisenyo
     * @request POST:api/Diseno/duplicardisenyo
     * @secure
     */
    disenoDuplicarDisenyo: (input: DuplicarDisenyoInput, params: RequestParams = {}) =>
      this.request<GuardarDisenoOutput, any>({
        path: `api/Diseno/duplicardisenyo`,
        method: 'POST',
        body: input,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diseno
     * @name DisenoGuardarDetalleDisenyo
     * @request POST:api/Diseno/guardardetalledisenyo
     * @secure
     */
    disenoGuardarDetalleDisenyo: (detalle: FEDetalleDisenosCabDTO, params: RequestParams = {}) =>
      this.request<File | null, any>({
        path: `api/Diseno/guardardetalledisenyo`,
        method: 'POST',
        body: detalle,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diseno
     * @name DisenoGetHqVisualesNombradas
     * @request GET:api/Diseno/gethqvisualesnombradas/{idVersiones}
     * @secure
     */
    disenoGetHqVisualesNombradas: (idVersiones: number, params: RequestParams = {}) =>
      this.request<FEVisualNombradaWithoutNameDTO[], any>({
        path: `api/Diseno/gethqvisualesnombradas/${idVersiones}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diseno
     * @name DisenoGeneratePdfDocVenta
     * @request POST:api/Diseno/generatepdfdocventa
     * @secure
     */
    disenoGeneratePdfDocVenta: (input: GeneratePdfDocVentaInput, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `api/Diseno/generatepdfdocventa`,
        method: 'POST',
        body: input,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diseno
     * @name DisenoCalcPrecioTotal
     * @request POST:api/Diseno/calcpreciototal
     * @secure
     */
    disenoCalcPrecioTotal: (unidades: Unidad[], params: RequestParams = {}) =>
      this.request<number, any>({
        path: `api/Diseno/calcpreciototal`,
        method: 'POST',
        body: unidades,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diseno
     * @name DisenoCalcPrecioUnidad
     * @request POST:api/Diseno/calcpreciounidad
     * @secure
     */
    disenoCalcPrecioUnidad: (unidad: Unidad, params: RequestParams = {}) =>
      this.request<number, any>({
        path: `api/Diseno/calcpreciounidad`,
        method: 'POST',
        body: unidad,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HQRender
     * @name HqRenderGlbFrontToBack
     * @request POST:api/HQRender/glbfronttoback/{idVersiones}/{hdrname}
     * @secure
     */
    hqRenderGlbFrontToBack: (idVersiones: number, hdrname: string, params: RequestParams = {}) =>
      this.request<File | null, any>({
        path: `api/HQRender/glbfronttoback/${idVersiones}/${hdrname}`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HQRender
     * @name HqRenderGetHdrs
     * @request GET:api/HQRender/gethdrs
     * @secure
     */
    hqRenderGetHdrs: (params: RequestParams = {}) =>
      this.request<UrlNameDTO[], any>({
        path: `api/HQRender/gethdrs`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HQRender
     * @name HqRenderBorrarRender
     * @request GET:api/HQRender/borrarrender/{idHqrenders}
     * @secure
     */
    hqRenderBorrarRender: (idHqrenders: number, params: RequestParams = {}) =>
      this.request<File | null, any>({
        path: `api/HQRender/borrarrender/${idHqrenders}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags I18N
     * @name I18NGetIdiomas
     * @request GET:api/I18N/getIdiomas
     * @secure
     */
    i18NGetIdiomas: (params: RequestParams = {}) =>
      this.request<IdiomaDTO[], any>({
        path: `api/I18N/getIdiomas`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags I18N
     * @name I18NLoadIdioma
     * @request GET:api/I18N/loadIdioma
     * @secure
     */
    i18NLoadIdioma: (
      query?: {
        nombreCultura?: string
      },
      params: RequestParams = {},
    ) =>
      this.request<LoadIdiomaOutput, any>({
        path: `api/I18N/loadIdioma`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Menu
     * @name MenuGetMenu
     * @request POST:api/Menu/getmenu
     * @secure
     */
    menuGetMenu: (input: GetMenuInput, params: RequestParams = {}) =>
      this.request<FEMenusDTO, any>({
        path: `api/Menu/getmenu`,
        method: 'POST',
        body: input,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Menu
     * @name MenuBusquedaMenu
     * @request POST:api/Menu/busquedaMenu
     * @secure
     */
    menuBusquedaMenu: (input: FiltroMenu, params: RequestParams = {}) =>
      this.request<FEMenusDTO, any>({
        path: `api/Menu/busquedaMenu`,
        method: 'POST',
        body: input,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prefs
     * @name PrefsUpdatePreference
     * @request POST:api/Prefs/updatePreference
     * @secure
     */
    prefsUpdatePreference: (input: UpdatePreferenceInput, params: RequestParams = {}) =>
      this.request<MessageOutput, any>({
        path: `api/Prefs/updatePreference`,
        method: 'POST',
        body: input,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prefs
     * @name PrefsUpdatePrefNoEditable
     * @request GET:api/Prefs/updateprefnoeditable/{nombre}/{value}
     * @secure
     */
    prefsUpdatePrefNoEditable: (nombre: string, value: boolean, params: RequestParams = {}) =>
      this.request<File | null, any>({
        path: `api/Prefs/updateprefnoeditable/${nombre}/${value}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Texturas
     * @name TexturasGetGruposTexturas
     * @request POST:api/Texturas/getgrupostexturas
     * @secure
     */
    texturasGetGruposTexturas: (input: GetGrupoTexturasInput, params: RequestParams = {}) =>
      this.request<GrupoTexturasDTO[], any>({
        path: `api/Texturas/getgrupostexturas`,
        method: 'POST',
        body: input,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Texturas
     * @name TexturasGetTexturas
     * @request POST:api/Texturas/gettexturas
     * @secure
     */
    texturasGetTexturas: (input: GetTexturasInput, params: RequestParams = {}) =>
      this.request<TexturasDTO[], any>({
        path: `api/Texturas/gettexturas`,
        method: 'POST',
        body: input,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Texturas
     * @name TexturasGetTextura
     * @request GET:api/Texturas/gettextura/{catalog}/{identificadorTextura}
     * @secure
     */
    texturasGetTextura: (
      catalog: string,
      identificadorTextura: number,
      params: RequestParams = {},
    ) =>
      this.request<TexturasDTO, any>({
        path: `api/Texturas/gettextura/${catalog}/${identificadorTextura}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Unidades
     * @name UnidadesGetUnidadGet
     * @request GET:api/Unidades/getunidad/{idunidades}
     * @secure
     */
    unidadesGetUnidadGet: (idUnidades: number, idunidades: string, params: RequestParams = {}) =>
      this.request<FEUnidadDTO, any>({
        path: `api/Unidades/getunidad/${idunidades}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Unidades
     * @name UnidadesGetUnidadPost
     * @request POST:api/Unidades/getunidad
     * @secure
     */
    unidadesGetUnidadPost: (input: GetFEUnidadInput, params: RequestParams = {}) =>
      this.request<FEUnidadDTO, any>({
        path: `api/Unidades/getunidad`,
        method: 'POST',
        body: input,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Unidades
     * @name UnidadesGetInfoPuertaVentana
     * @request GET:api/Unidades/getinfopuertaventa/{idUnidades}
     * @secure
     */
    unidadesGetInfoPuertaVentana: (idUnidades: number, params: RequestParams = {}) =>
      this.request<GetFEInfoPuertaVentanaOutput, any>({
        path: `api/Unidades/getinfopuertaventa/${idUnidades}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  u = {
    /**
     * No description
     *
     * @tags ActivateAccount
     * @name ActivateAccountIndex
     * @request GET:/u/activate-account/{token}
     * @secure
     */
    activateAccountIndex: (token: string, params: RequestParams = {}) =>
      this.request<File | null, any>({
        path: `/u/activate-account/${token}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HQRenderU
     * @name HqRenderUIndex
     * @request GET:/u/proyectofinalizado
     * @secure
     */
    hqRenderUIndex: (
      query?: {
        /** @format int32 */
        idHqrenders?: number | null
      },
      params: RequestParams = {},
    ) =>
      this.request<File | null, any>({
        path: `/u/proyectofinalizado`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HQRenderU
     * @name HqRenderUPngGenerado
     * @request GET:/u/pnggenerado/{keyHqrender}
     * @secure
     */
    hqRenderUPngGenerado: (keyHqrender: string, params: RequestParams = {}) =>
      this.request<File | null, any>({
        path: `/u/pnggenerado/${keyHqrender}`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  }
}
